import React, { Component } from "react";
import $ from "jquery";

import SVGnumber from "./SVGnumber";

import arrowIcon from "../assets/images/icons/svg/arrow-small-orange.svg";

import "../styles/components/SectionFaq.css";
const Parser = require("html-react-parser");

export default class SectionFAQ extends Component {
  componentDidMount() {
    $(".question").each(function(elem) {
      const singleQuestion = $(this);
      $(this).click(() => {
        singleQuestion.toggleClass("active");
        singleQuestion.find(".answer").slideToggle();
        $(".section-faq ul li").each(function(item) {
          const elementLi = $(this);
          elementLi.find(".question").hasClass("active");
          if (elementLi.find(".question").hasClass("active")) {
            elementLi.addClass("active");
          } else {
            elementLi.removeClass("active");
          }
        });
      });
    });
  }

  render() {
    return (
      <div className="section-faq">
        <div className="container container-small">
          <div className="row">
            <div className="col-12">
              <ul>
                {this.props.elements.map((item, idx) => {
                  return (
                    <li className="row" key={idx}>
                      <div className="col-8 offset-2 col-sm-6 offset-sm-3 col-md-3 offset-md-0">
                        <div className="number-element">
                          <SVGnumber version={idx + 1} />
                          <span>{item.tytul_sekcji}</span>
                        </div>
                      </div>
                      <div className="col-12 col-md-9">
                        {item.single_element.map((item2, idx2) => {
                          return (
                            <div className="question" key={idx2}>
                              <h6>{item2.pole_title}</h6>
                              <img
                                className="svg"
                                style={{ display: "none" }}
                                src={arrowIcon}
                                alt="Question icon arrow"
                              />
                              <div className="answer">
                                {Parser(item2.pole_desc)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
